import Main from '../../types/enums/main';
import seasonRequest from './seasonRequest';
import { Observable } from 'rxjs';

const WAITING_TIME = 100;

function seasonObservable(id: string) {
  return new Observable((subscriber) => {
    seasonRequest(id).then((data) => {
      setTimeout(() => {
        subscriber.next({ data, type: Main.RAILS });
        subscriber.complete();
      }, WAITING_TIME);
    });
  });
}
export default seasonObservable;
